import React from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import type { TypographyProps } from 'components/ui/typography';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

import { Total, TotalLabel, TotalsRow } from './styled';
import { IRenderTotalsProps } from './types';
import { capitalizeFeeName, getFeesByGroup, getStandardizedName } from './utils';

interface FeeRowsProps {
  fees?: NonNullable<IRenderTotalsProps['cart']>['fees'];
  isLoading?: boolean;
  textProps?: TypographyProps;
}

export const FeeRows: React.FC<FeeRowsProps> = ({ fees = [], isLoading, textProps }) => {
  const itemFees = getFeesByGroup(fees);

  return (
    <>
      {Object.entries(itemFees).map(([name, entryCents]) =>
        isLoading ? (
          <CurrencyLineSkeleton key={name} />
        ) : (
          <TotalsRow key={name}>
            <A11yWrapper>
              <TotalLabel testID={`fee-name-${name}`}>
                {capitalizeFeeName(
                  t(`${getStandardizedName({ name })}Fee` as TranslationKey, name)
                )}
              </TotalLabel>
            </A11yWrapper>
            <Total testID={`fee-amount-${name}`}>
              <Currency amount={entryCents} textProps={textProps} />
            </Total>
          </TotalsRow>
        )
      )}
    </>
  );
};
